module.exports = __webpack_public_path__ + "img/eatout-2.14eeba3b.svg";